import { tabletMax } from '@propertypal/shared/src/constants/mediaQueries';
import styled from 'styled-components';
import { MAX_WIDTH } from '../layout/PageWrapper.style';

export const LoadingBox = styled.div`
  height: 300px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  margin: 60px auto;
  width: 100%;
  max-width: ${MAX_WIDTH - 60}px;
`;

export const Cell = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;
  flex-direction: column;
  min-height: 70px;
  max-height: 70px;
  padding: 0 10px;
  border-bottom: 1px solid ${(props) => props.theme.backgroundLight};
  border-right: 1px solid ${(props) => props.theme.backgroundLight};

  p {
    font-size: 14px;
    text-align: center;
    color: ${(props) => props.theme.textDark};
  }

  b {
    color: ${(props) => props.theme.primary};
  }

  @media (${tabletMax}) {
    p {
      font-size: 12px;
    }
  }
`;

export const Labels = styled.div`
  display: flex;
  flex-direction: column;
  width: 300px;

  ${Cell} {
    background: ${(props) => props.theme.backgroundMid};

    p {
      color: ${(props) => props.theme.background};
      text-align: left;
      font-weight: 600;
    }
  }

  ${Cell}:first-child {
    background: ${(props) => props.theme.backgroundDark};
  }

  @media (${tabletMax}) {
    width: 180px;
  }
`;

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;

  ${Cell}:nth-child(1n+1) {
    background: ${(props) => props.theme.backgroundLightest};
  }

  ${Cell}:nth-child(2n+1) {
    background: ${(props) => props.theme.backgroundLighter};
  }

  ${Cell}:first-child {
    background: ${(props) => props.theme.backgroundDark};

    p {
      font-weight: 600;
      color: ${(props) => props.theme.background};
    }
  }
`;
